import $http from "../../../axios-instance";
import Swal from "sweetalert2";
import { Notification } from "element-ui";
const moment = require("moment");

/**
 * Metodo que devuelve los peligros de CAS.
 *
 * @return {Array}
 */
export async function listarTipoCas({ commit }) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("cas/list-type-cas")
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setTiposCas", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Metodo que devuelve los controles de lista.
 *
 * @param {*} control nombre del control de lista
 * @return {Array}
 */
export async function ListarControles({ commit }, control) {
    if (control.length >= 3) {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/control-lists", { control: control })
            .then((response) => {
                commit("dashboard/load", false, { root: true });
                commit("setControles", response.data);
            })
            .catch((error) => {
                commit("dashboard/load", false, { root: true });
            });
    }
}

/**
 * Metodo crear nuevo peligro.
 *
 * @param {*} data nombre del peligro y sus campos.
 * @returns
 */
export async function crearPeligro({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/crear-peligro", data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        setTimeout(() => {
                            Notification.error({
                                title: "Error",
                                type: "error",
                                message: error.errors[val][0],
                                duration: 8000,
                            });
                        }, 100);
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo crear nuevo campo de peligro.
 *
 * @param {*} data label del peligro y sus campos.
 * @returns
 */
export async function crearCamposPeligro({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/crear-campo-peligro", data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        setTimeout(() => {
                            Notification.error({
                                title: "Error",
                                type: "error",
                                message: error.errors[val][0],
                                duration: 8000,
                            });
                        }, 100);
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo para actualizar campo de peligro.
 *
 * @param {*} campo datos del campo de peligro a actualizar.
 * @returns
 */
export async function actualizarCampoPeligro({ commit }, campo) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post("cas/actualizar-campo-peligro", campo)
        .then(async (response) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                timer: 2000,
            });
        })
        .catch(async (error) => {
            commit("dashboard/load", false, { root: true });
            if (error.message) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000,
                });
            }
            if (error.errors) {
                Object.getOwnPropertyNames(error.errors).forEach(function (
                    val
                ) {
                    setTimeout(() => {
                        Notification.error({
                            title: "Error",
                            type: "error",
                            message: error.errors[val][0],
                            duration: 8000,
                        });
                    }, 100);
                });
            }
        });
}

/**
 * Metodo que devuelve los componentes activos segun la busqueda.
 *
 * @param {*} componente nombre del componente o numero de cas
 * @return {Array}
 */
export async function ListarComponentes({ commit }, componente) {
    if (componente.length >= 3 || componente.length == undefined) {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/buscar-componente", { buscar: componente })
            .then((response) => {
                commit("dashboard/load", false, { root: true });
                commit("setComponentes", response.data);
            })
            .catch((error) => {
                commit("dashboard/load", false, { root: true });
            });
    }
}

/**
 * Metodo que devuelve los componentes de un peligro en especifico segun la busqueda.
 *
 * @param {*} params nombre del componente o numero de cas y el id del peligro.
 * @return {Array}
 */
export async function listarComponenteSegunPeligro(
    { state, commit },
    requestParameters = { params: state.parametrosBuscador }
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("cas/componente-segun-peligro", requestParameters)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setComponentesPeligro", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        });
}

/**
 * Metodo que edita los valores de un componentes de peligro en especifico.
 *
 * @param {*} componente_id id del componente.
 * @return {Array}
 */
export async function buscarValoresComponente({ commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(
            `cas/buscar-valores-componente/${data.componente_id}/${data.peligro_id}`
        )
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setValoresComponentePeligro", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        });
}

/**
 * Metodo que pagina total de componentes de peligro por pagina.
 *
 * @param {*} perPage numero de componentes por pagina.
 * @return {Array}
 */
export async function setPorPaginaComponentes({ commit, dispatch }, perPage) {
    commit("setPorPagina", parseInt(perPage));
    await dispatch("listarComponenteSegunPeligro");
}

/**
 * Metodo que cambia de pagina en la tabla de componenetes.
 *
 * @param {*} page pagina componentes.
 * @return {Array}
 */
export async function setPaginaComponente({ commit, dispatch }, page) {
    commit("setPagina", parseInt(page));
    await dispatch("listarComponenteSegunPeligro");
}

/**
 * Metodo que cambia de estado (Activo/Inactivo) los valores de un componente.
 *
 * @param {*} data componente_id, peligro_id, activo (estado actual).
 * @return {Array}
 */
export async function estadoComponenteValores({ commit, dispatch }, data) {
    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si",
    }).then(async (result) => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });
            await $http
                .put(`cas/estado-componente-valores`, data)
                .then(async (response) => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    await dispatch("listarComponenteSegunPeligro");
                })
                .catch((error) => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 5000,
                    });
                });
        }
    });
}

/**
 * Metodo que crea los valores de un componente.
 *
 * @param {*} data valores, componente_id, peligro_id.
 * @returns
 */
export async function crearComponenteValores({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/crear-componente-valores", data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        if (val !== "length") {
                            setTimeout(() => {
                                Notification.error({
                                    title: "Error",
                                    type: "error",
                                    message: error.errors[val][0],
                                    duration: 3000,
                                });
                            }, 100);
                        }
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo que actualiza los valores de un componente.
 *
 * @param {*} data valores, componente_id, peligro_id.
 * @returns
 */
export async function actualizarComponenteValores({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/actualizar-componente-valores", data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        if (val !== "length") {
                            setTimeout(() => {
                                Notification.error({
                                    title: "Error",
                                    type: "error",
                                    message: error.errors[val][0],
                                    duration: 3000,
                                });
                            }, 100);
                        }
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo que devuelve todos los componentes.
 *
 * @param {*} params sortBy, sort, perPage.
 * @return {Array}
 */
export async function listarComponentes(
    { state, commit },
    requestParameters = { params: state.parametrosBuscadorComponente }
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("cas/lista-componentes", requestParameters)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("establecerTodosComponentes", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        });
}

/**
 * Metodo que pagina todos los componentes.
 *
 * @param {*} perPage numero de componentes por pagina.
 * @return {Array}
 */
export async function setPorPaginaTodosComponentes(
    { commit, dispatch },
    perPage
) {
    commit("setPorPaginaComponentes", parseInt(perPage));
    await dispatch("listarComponentes");
}

/**
 * Metodo que cambia de pagina en el tag de componenetes.
 *
 * @param {*} page pagina componentes.
 * @return {Array}
 */
export async function setPaginaTodosComponente({ commit, dispatch }, page) {
    commit("setPaginaComponentes", parseInt(page));
    await dispatch("listarComponentes");
}

/**
 * Metodo que cambia de estado (Activo/Inactivo) de un componente.
 *
 * @param {*} data componente_id, activo (estado actual).
 * @return {Array}
 */
export async function estadoComponente({ commit, dispatch }, data) {
    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si",
    }).then(async (result) => {
        if (result.value) {
            commit("dashboard/load", true, { root: true });
            await $http
                .put(`cas/estado-componente`, data)
                .then(async (response) => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    await dispatch("listarComponentes");
                })
                .catch((error) => {
                    commit("dashboard/load", false, { root: true });
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: error.message,
                        showConfirmButton: true,
                        timer: 5000,
                    });
                });
        }
    });
}

/**
 * Metodo que busca un componente.
 *
 * @param {*} componente_id id del componente.
 * @return {Array}
 */
export async function buscarComponente({ commit }, componente_id) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get(`cas/buscar-componente/${componente_id}`)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setComponente", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        });
}

/**
 * Metodo crear nuevo componente.
 *
 * @param {*} data nombre del componente y numero de cas si tiene.
 * @returns
 */
export async function crearComponente({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/crear-componente", data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (this.$vue.$alertErrorsCallback(error)) return false;
                this.$vue.$alertError(error.message);
                reject("Error");
            });
    });
}

/**
 * Metodo actualiza componente.
 *
 * @param {*} data id del componente, nombre del componente y numero de cas.
 * @returns
 */
export async function actualizarComponente({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/actualizar-componente/" + data.id, data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (this.$vue.$alertErrorsCallback(error)) return;
                this.$vue.$alertError(error.message);
                reject("Error");
            });
    });
}

/**
 * Metodo que devuelve los componentes de un producto.
 *
 * @param {*} producto_id id del producto
 * @return {Array}
 */
export async function ListarComponentesPorProducto(
    { commit },
    { producto_id, prod_attachment_id }
) {
    commit("dashboard/load", true, { root: true });
    await $http
        .get("cas/lista-componente-producto/" + producto_id, {
            params: { prod_attachment_id },
        })
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setComponentesProducto", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Metodo agregar componente a producto.
 *
 * @param {*} data valores y producto_id.
 * @returns
 */
export async function agregarComponenteProduct({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post(`cas/agregar-componente-producto/${data.producto_id}`, data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                commit("resetFormComponente");
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        setTimeout(() => {
                            Notification.error({
                                title: "Error",
                                type: "error",
                                message: error.errors[val][0],
                                duration: 8000,
                            });
                        }, 100);
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo que cambia de estado inactivo a un componente de un producto.
 *
 * @param {*} data componente_id, producto_id.
 * @return {Array}
 */
export async function inactivarComponenteProducto(
    { commit },
    prodComponentProductId
) {
    await Swal.fire({
        title: "Eliminar componente",
        text: "¿Está seguro de eliminar el componente?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si",
    }).then(async (result) => {
        if (result.value) {
            return new Promise(async (resolve, reject) => {
                commit("dashboard/load", true, { root: true });
                await $http
                    .put(
                        `cas/estado-componente-producto/${prodComponentProductId}`
                    )
                    .then(async (response) => {
                        commit("dashboard/load", false, { root: true });
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                        resolve();
                    })
                    .catch((error) => {
                        commit("dashboard/load", false, { root: true });
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.message,
                            showConfirmButton: true,
                            timer: 5000,
                        });
                        reject("Error");
                    });
            });
        }
    });
}

/**
 * Metodo actualiza componente de un producto.
 *
 * @param {*} data id del componente producto y sus valores.
 * @returns
 */
export async function actualizarComponenteProducto({ commit }, data) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .post("cas/actualizar-componente-producto/" + data.id, data)
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        setTimeout(() => {
                            Notification.error({
                                title: "Error",
                                type: "error",
                                message: error.errors[val][0],
                                duration: 8000,
                            });
                        }, 100);
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo que devuelve todos los peligros con sus componentes.
 *
 * @param {*} data ids de los componentes.
 *
 * @return {Array}
 */
export async function ListarComponentesPorPeligro({ commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post("cas/buscar-componente-peligro", data)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setComponentesProductoPeligro", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Metodo que cambia visibilidad de un componente.
 *
 * @param {*} data componente_id, peligro_id.
 * @return {Array}
 */
export async function actualizarVisibleComponente({ commit }, data) {
    await Swal.fire({
        title: "Cambiar estado",
        text: "¿Está seguro de cambiar el estado?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si",
    }).then(async (result) => {
        if (result.value) {
            return new Promise(async (resolve, reject) => {
                commit("dashboard/load", true, { root: true });
                await $http
                    .post("cas/visible-componente-producto", data)
                    .then(async (response) => {
                        commit("dashboard/load", false, { root: true });
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: response.data.message,
                            timer: 2000,
                        });
                        resolve();
                    })
                    .catch(async (error) => {
                        commit("dashboard/load", false, { root: true });
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.message,
                            showConfirmButton: true,
                            timer: 5000,
                        });
                        reject("Error");
                    });
            });
        }
    });
}

/**
 * Descargar los registros de componentes por peligro.
 *
 * @param Object { danger } peligro - plantilla con datos
 * @return {File}
 */
export async function downloadRegistersDanger({ commit }, { danger }) {
   
    commit("dashboard/load", true, { root: true });
    await $http({
        url: `cas/download-registers-danger/${danger.id}`,
        method: "GET",
        responseType: "blob"
    })
        .then((response) => {
            const nameFile = "Registros_" + danger.lista + "_" + moment().format("YYYY-MM-DD HH:mm:ss") + ".xlsx";
            window.downloadFile(response.data, nameFile);
        })
        .catch((error) => {
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        })
        .finally(() => commit("dashboard/load", false, { root: true }));
}
/**
 * Cargar los registros de componentes por peligro.
 *
 * @param Object { danger } peligro - plantilla con datos
 * @return {File}
 */
export async function uploadRegistersDanger({ commit }, { danger, file }) {
   
    commit('setResponseUpFileExcelComponents', null);
    commit('dashboard/load', true, { root: true });
    let formData = new FormData();
    formData.append('danger_id', danger.id);
    formData.append('file', file);
    await $http({
            url: `cas/upload-registers-danger`,
            method: "POST",
            data: formData
        })
        .then(({data: response}) =>{
            commit('setResponseUpFileExcelComponents', response.data)
            let message = "Proceso exitoso.";
            if (response.data && typeof response.data === 'object') {
                message = 'Proceso completado con algunas complicaciones.';
            }
            this.$vue.$alertSuccess(message, 7000);
        })
        .catch((error) => this.$vue.$alertError(error.message, 7000))
        .finally(() => commit("dashboard/load", false, { root: true }));
        
        
}

/**
 * Metodo que devuelve todos los peligros por componentes.
 *
 * @param {*} data ids de los componentes.
 *
 * @author Brandon Torres
 * @return {Array}
 */
export async function dangersForComponents({ commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post("cas/danger-for-component", data)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            commit("setComponentesProductoPeligro", response.data);
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Actualizar todos los componentes del producto.
 *
 * @param {*} payload
 * @returns
 */
export async function updateComponentsMassive({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
        commit("dashboard/load", true, { root: true });
        await $http
            .patch("cas/update-components-massive", { components: payload })
            .then(async (response) => {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    timer: 2000,
                });
                resolve();
            })
            .catch(async (error) => {
                commit("dashboard/load", false, { root: true });
                if (error.errors) {
                    Object.getOwnPropertyNames(error.errors).forEach(function (
                        val
                    ) {
                        setTimeout(() => {
                            Notification.error({
                                title: "Error",
                                type: "error",
                                message: error.errors[val][0],
                                duration: 8000,
                            });
                        }, 100);
                    });
                }
                reject("Error");
            });
    });
}

/**
 * Metodo que aprueba o desaprueba los componentes.
 *
 * @param {*} componentApprove datos del componente a aprobar o desaprobar.
 *
 * @author Brandon Torres
 * @return {Boolean}
 */
export async function componentApproved({ commit }, componentApprove) {
    commit("dashboard/load", true, { root: true });

    try {
        const response = await $http.post(
            "cas/component-approved",
            componentApprove
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        this.$vue.$alertError(error.message);
        return false;
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Metodo que devuelve el listado de  componentes aprobados y desaprobados.
 *
 * @param {*} component_id id del componente.
 *
 * @author Brandon Torres
 * @return {Array}
 */
export async function getProdComponentApproved({ commit }, component_id) {
    commit("dashboard/load", true, { root: true });

    try {
        const response = await $http.get(
            `cas/approved-list-by-component/${component_id}`
        );
        commit("setProdComponentApprovedList", response.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
